import { BasicRequest } from "./basicRequest";

export class UndeleteVendorRequest extends BasicRequest{

    public vendorId! : number;
  
    constructor(){
        super();
    }
}